const ANIMATION_DURATION = 1;

export default ANIMATION_DURATION;
